import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/bi-events.js';
// this is a dummy comment intended to generate a new gridAppId



$w.onReady(function () {

   $w('#btnBox').onClick(() => {
            const biFields = {
                button_name: $w('#btnSupport').label,
                additional_info: 'EN HP BANNER (Desktop)',
                topic: 'lp banner',
                url: wixLocation.url,
                target_url: $w('#btnSupport').link,
                is_valid: true,
            }
            fireBIEvent(19, 703, biFields);
        })

});